/* Rey Vinilo · comportamiento: (i) del envío, buscador por gama, añadir al carrito, pie plegable en móvil. */
(function () {
  function closeTips() {
    document.querySelectorAll('.rv-free__tip').forEach(function (t) {
      t.hidden = true;
      var b = document.querySelector('[aria-controls="' + t.id + '"]');
      if (b) b.setAttribute('aria-expanded', 'false');
    });
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.rv-free__i');
    if (btn) {
      e.stopPropagation();
      var tip = document.getElementById(btn.getAttribute('aria-controls'));
      var open = tip.hidden;
      closeTips();
      tip.hidden = !open;
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      return;
    }
    if (!e.target.closest('.rv-free__tip')) closeTips();
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeTips(); });
  document.addEventListener('mouseover', function (e) {
    var btn = e.target.closest('.rv-free__i');
    if (btn && window.matchMedia('(hover: hover)').matches) {
      var tip = document.getElementById(btn.getAttribute('aria-controls'));
      tip.hidden = false;
      btn.setAttribute('aria-expanded', 'true');
    }
  });
  document.addEventListener('mouseout', function (e) {
    var wrap = e.target.closest('.rv-free');
    if (wrap && !wrap.contains(e.relatedTarget) && window.matchMedia('(hover: hover)').matches) closeTips();
  });

  /* Desplegable de gamas con miniatura: sustituye al select nativo (que se queda como respaldo) */
  document.querySelectorAll('[data-rv-dd]').forEach(function (dd) {
    var form = dd.closest('[data-rv-finder]');
    var sel = form && form.querySelector('[data-rv-gama]');
    if (!sel) return;
    var btn = dd.querySelector('.rv-dd__btn');
    var list = dd.querySelector('.rv-dd__list');
    var opts = Array.prototype.slice.call(list.querySelectorAll('[role="option"]'));
    var active = 0;
    dd.hidden = false;
    form.classList.add('rv-js-dd');
    opts.forEach(function (o, i) { o.id = list.id + '-' + i; });
    function setActive(i) {
      active = Math.max(0, Math.min(opts.length - 1, i));
      opts.forEach(function (o, j) { o.classList.toggle('is-active', j === active); });
      list.setAttribute('aria-activedescendant', opts[active].id);
      opts[active].scrollIntoView({ block: 'nearest' });
    }
    function open() {
      list.hidden = false; btn.setAttribute('aria-expanded', 'true');
      var cur = opts.findIndex(function (o) { return o.getAttribute('aria-selected') === 'true'; });
      setActive(cur < 0 ? 0 : cur); list.focus();
    }
    function close(focusBtn) {
      list.hidden = true; btn.setAttribute('aria-expanded', 'false');
      if (focusBtn) btn.focus();
    }
    function choose(i) {
      var o = opts[i];
      opts.forEach(function (x) { x.setAttribute('aria-selected', x === o ? 'true' : 'false'); });
      sel.value = o.dataset.value;
      btn.querySelector('.rv-th').className = o.querySelector('.rv-th').className;
      btn.querySelector('.rv-dd__val').textContent = o.textContent.trim();
      close(true);
      window.location.href = o.dataset.value;   /* al elegir una gama se va directo a ella */
    }
    btn.addEventListener('click', function () { list.hidden ? open() : close(true); });
    btn.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') { e.preventDefault(); open(); }
    });
    list.addEventListener('click', function (e) {
      var o = e.target.closest('[role="option"]');
      if (o) choose(opts.indexOf(o));
    });
    list.addEventListener('mousemove', function (e) {
      var o = e.target.closest('[role="option"]');
      if (o) setActive(opts.indexOf(o));
    });
    list.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown') { e.preventDefault(); setActive(active + 1); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); setActive(active - 1); }
      else if (e.key === 'Home') { e.preventDefault(); setActive(0); }
      else if (e.key === 'End') { e.preventDefault(); setActive(opts.length - 1); }
      else if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); choose(active); }
      else if (e.key === 'Escape' || e.key === 'Tab') { close(e.key === 'Escape'); }
    });
    document.addEventListener('click', function (e) { if (!dd.contains(e.target)) close(false); });
  });

  /* respaldo sin el desplegable propio: el select nativo también lleva directo a la gama */
  document.addEventListener('change', function (e) {
    if (e.target.matches('[data-rv-gama]')) window.location.href = e.target.value;
  });

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-rv-finder]');
    if (!form) return;
    e.preventDefault();
    var sel = form.querySelector('[data-rv-gama]');
    window.location.href = sel ? sel.value : form.action;
  });

  // El selector de «Completa tu pedido» está dentro del formulario del carrito: que Dawn no lo tome por un cambio de cantidad
  ['change', 'input'].forEach(function (t) {
    document.addEventListener(t, function (e) { if (e.target.closest && e.target.closest('.rv-up')) e.stopPropagation(); }, true);
  });

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-rv-add]');
    if (!btn || btn.disabled) return;
    var vid = btn.dataset.rvAdd;
    if (vid === 'select') {
      var sel = btn.parentNode.querySelector('select');
      vid = sel ? sel.value : '';
    }
    if (!vid) return;
    var onCartPage = !!btn.closest('[data-rv-cart-page]');
    var label = btn.querySelector('span');
    var original = label ? label.textContent : '';
    btn.disabled = true;
    var sections = ['cart-icon-bubble', 'cart-drawer'];
    fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(vid), quantity: 1 }], sections: sections }),
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status) throw new Error(data.description || data.message);
        if (onCartPage) { window.location.reload(); return; }
        var bubble = document.getElementById('cart-icon-bubble');
        if (bubble && data.sections && data.sections['cart-icon-bubble']) {
          var doc = new DOMParser().parseFromString(data.sections['cart-icon-bubble'], 'text/html');
          var inner = doc.querySelector('.shopify-section');
          bubble.innerHTML = inner ? inner.innerHTML : bubble.innerHTML;
        }
        var drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.renderContents === 'function' && data.sections && data.sections['cart-drawer']) {
          drawer.classList.remove('is-empty');
          drawer.renderContents({ id: data.items && data.items[0] ? data.items[0].id : null, sections: data.sections });
        } else {
          btn.classList.add('is-done');
          if (label) label.textContent = btn.dataset.rvAdded || '✓';
          setTimeout(function () { btn.classList.remove('is-done'); if (label) label.textContent = original; }, 2000);
        }
      })
      .catch(function () { window.location.href = (window.routes && window.routes.cart_url) || '/cart'; })
      .finally(function () { btn.disabled = false; });
  });

  // Todos los vinilos: muestra 20 productos más cada vez que se llega al final de la lista
  (function () {
    var sentinel = document.querySelector('[data-rv-more]');
    if (!sentinel) return;
    function more() {
      var hidden = document.querySelectorAll('#product-grid .rv-more');
      for (var i = 0; i < hidden.length && i < 20; i++) hidden[i].classList.remove('rv-more');
      if (hidden.length <= 20) { io && io.disconnect(); sentinel.remove(); return; }
      if (io) { io.unobserve(sentinel); io.observe(sentinel); }
    }
    var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (es) {
      if (es.some(function (e) { return e.isIntersecting; })) more();
    }, { rootMargin: '600px 0px' }) : null;
    if (io) io.observe(sentinel); else document.querySelectorAll('#product-grid .rv-more').forEach(function (li) { li.classList.remove('rv-more'); });
  })();

  function foldFooter() {
    if (!window.matchMedia('(max-width: 749px)').matches) return;
    document.querySelectorAll('.rv-fcol[open]').forEach(function (d) { d.removeAttribute('open'); });
  }
  document.addEventListener('click', function (e) {
    var s = e.target.closest('.rv-fcol summary');
    if (s && !window.matchMedia('(max-width: 749px)').matches) e.preventDefault();
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', foldFooter); else foldFooter();
  var mq = window.matchMedia('(max-width: 749px)');
  var onChange = function () {
    if (mq.matches) foldFooter();
    else document.querySelectorAll('.rv-fcol').forEach(function (d) { d.setAttribute('open', ''); });
  };
  if (mq.addEventListener) mq.addEventListener('change', onChange);
})();

/* Gamas en móvil: flechas para desplazar la fila; se ocultan al llegar a cada extremo. */
(function () {
  document.querySelectorAll('.rv-gam__wrap').forEach(function (w) {
    var list = w.querySelector('.rv-gam__list');
    var prev = w.querySelector('.rv-gam__nav--prev');
    var next = w.querySelector('.rv-gam__nav--next');
    if (!list || !prev || !next) return;
    function upd() {
      prev.hidden = list.scrollLeft < 8;
      next.hidden = list.scrollLeft + list.clientWidth >= list.scrollWidth - 8;
    }
    prev.addEventListener('click', function () { list.scrollBy({ left: -list.clientWidth * 0.8, behavior: 'smooth' }); });
    next.addEventListener('click', function () { list.scrollBy({ left: list.clientWidth * 0.8, behavior: 'smooth' }); });
    list.addEventListener('scroll', upd, { passive: true });
    window.addEventListener('resize', upd);
    upd();
  });

  /* Barra superior: si en algún idioma no cabe en una línea, se quita primero la frase y después la aclaración de la tienda del grupo */
  (function () {
    var bar = document.querySelector('.rv-top__in');
    if (!bar || !window.matchMedia) return;
    var mq = window.matchMedia('(min-width: 750px)');
    function fit() {
      bar.classList.remove('rv-top--t1', 'rv-top--t2');
      if (!mq.matches) return;
      if (bar.scrollWidth > bar.clientWidth + 1) bar.classList.add('rv-top--t1');
      if (bar.scrollWidth > bar.clientWidth + 1) bar.classList.add('rv-top--t2');
    }
    window.addEventListener('resize', fit);
    fit();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(fit);
  })();

  /* Desplegables de la barra superior (país e idioma): se cierran al pulsar fuera o al abrir el otro */
  document.addEventListener('click', function (e) {
    document.querySelectorAll('.rv-lang[open]').forEach(function (d) { if (!d.contains(e.target)) d.removeAttribute('open'); });
  });
})();
